export default __webpack_public_path__ + "static/media/valleySide.2580bc9d.png";